export default __webpack_public_path__ + "static/media/add_product-stap_03.5ae67973.png";